import { connect } from 'react-redux';

import {
  getOfficesShortList,
  getPublicZoneList,
} from '../../Offices/officesActions';
import { getOrganizationMembersList } from '../../Projects/projectsActions';
import { getComplaintsList } from '../complaintsActions';
import ComplaintsFilter from './ComplaintsFilter';

const ComplaintsFilterContainer = ({
  publicZoneList,
  getPublicZoneList,
  officesShortList,
  getOfficesShortList,
  getComplaintsList,
  selectedOrganization,
  organizationMembersList,
  getOrganizationMembersList,
  setSelectedParams,
  selectedParams,
}) => {
  return (
    <ComplaintsFilter
      publicZoneList={publicZoneList}
      getPublicZoneList={getPublicZoneList}
      officesShortList={officesShortList}
      getOfficesShortList={getOfficesShortList}
      getComplaintsList={getComplaintsList}
      selectedOrganization={selectedOrganization}
      organizationMembersList={organizationMembersList}
      getOrganizationMembersList={getOrganizationMembersList}
      setSelectedParams={setSelectedParams}
      selectedParams={selectedParams}
    />
  );
};

const mapStateToProps = state => ({
  publicZoneList: state.office.publicZoneList,
  officesShortList: state.office.officesShortList,
  selectedOrganization: state.organization.selectedOrganization,
  organizationMembersList: state.project.orgMembersList,
});

const mapDispatchToProps = dispatch => ({
  getPublicZoneList: params => dispatch(getPublicZoneList(params)),
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),
  getComplaintsList: params => dispatch(getComplaintsList(params)),
  getOrganizationMembersList: details =>
    dispatch(getOrganizationMembersList({ ...details })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ComplaintsFilterContainer);
